import Vue from 'vue'
import Vuex, { Store } from 'vuex'
import { createStore as vuexCreateStore, registerModule } from 'vuex-smart-module'

import { lkStoreModule } from './modules/lk'
import { preferenceStoreModule } from './modules/preference'
import { rootStoreModule } from './modules/root'


Vue.use(Vuex)

export const createStore = () => {
  const store = vuexCreateStore(
    rootStoreModule,
    { strict: process.env.NODE_ENV !== 'production' },
  ) as Store<unknown>

  registerModule(
    store,
    'preference',
    'preference',
    preferenceStoreModule,
  )

  registerModule(
    store,
    'lk',
    'lk',
    lkStoreModule,
  )

  return store
}
